// Priority Call
export default class Kmklabs {
  constructor({ element }) {
    this.element = element
    window.kmklabs = window.kmklabs || {};
    window.kmklabs.video = {
      id: this.getAttr("data-video-id"),
      film_id: this.getAttr("data-film-id"),
      premium: this.getAttr("data-video-premium"),
      owner_id: this.getAttr("data-owner-id"),
      content_type: this.getAttr("data-content-type"),
    };
    window.kmklabs.category = {
      id: this.getAttr("data-category-id"),
      name: this.getAttr("data-category-name")
    };
    window.kmklabs.collection = {
      id: this.getAttr("data-collection-id"),
      name: this.getAttr("data-collection-name")
    };
    window.kmklabs.source = this.getAttr("data-source");
    window.kmklabs.userType = this.getAttr("data-user-type");
    window.kmklabs.gtm = {
      category_id: this.getAttr("data-category-id"),
      category_name: this.getAttr("data-category-name"),
      collection_id: this.getAttr("data-collection-id"),
      collection_name: this.getAttr("data-collection-name"),
      source: this.getAttr("data-source"),
      userType: this.getAttr("data-user-type"),
      visitor_id: Kmklabs.getCookie("he_visitor_id") || Kmklabs.getCookie("ahoy_visitor"),
      video_id: this.getAttr("data-video-id"),
      user_id: this.getAttr("data-user-id"),
      user_name: this.getAttr("data-user-name"),
      user_full_name: this.getAttr("data-user-full-name"),
      user_birthdate: this.getAttr("data-user-birthdate"),
      ue: this.getAttr("data-user-email"),
      login_status: this.getAttr("data-user-id") ? true : false,
      platform: this.getAttr("data-platform"),
      tag: this.getAttr("data-tag"),
      owner_id: this.getAttr("data-owner-id"),
      owner_name: this.getAttr("data-owner-name"),
      live_id: this.getAttr("data-live-id"),
      live_title: this.getAttr("data-live-title"),
      live_type: this.getAttr("data-live-type"),
      user_gender: this.getAttr("data-user-gender")
    };
    window.kmklabs.ads = {
      title: this.getAttr('data-video-title') || this.getAttr('data-live-title'),
      category_name: this.getAttr("data-category-name") || '',
      collection_name: this.getAttr("data-collection-name") || '',
      advance_tag: this.getAttr('data-advance-tag') || '',
      adult_content: this.getAttr('data-adult-content') || 'false',
      film_name: this.getAttr('data-film-name'),
      season: this.getAttr('data-season'),
      livestreaming_tag: this.getAttr('data-livestreaming-tag'),
      main_genre: this.getAttr('data-main-genre'),
      genre: this.getAttr('data-genre'),
      film_id: this.getAttr('data-film-id'),
      content_country: this.getAttr('data-content-country'),
      content_premium: this.getAttr('data-content-premium'),
      content: this.getAttr('data-content')
    };
    window.kmklabs.watermark_timestamp = this.getAttr("data-watermark-timestamp");
    window.kmklabs.live = {
      streamRight: this.getAttr("data-live-stream-right"),
      chatEnabled: this.getAttr("data-live-chat-enabled")
    };
  }

  init(){
    // Initialization
  }

  getAttr(attr) {
    var value = this.element.getAttribute(attr)
    return value || ''
  }

  static getCookie(name) {
    var i, c;
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (i = 0; i < ca.length; i++) {
      c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) {
        return window.unescape(c.substring(nameEQ.length, c.length));
      }
    }
    return null;
  }

  static setVisitorId() {
    const visitor_id = this.getCookie("he_visitor_id") || this.getCookie("ahoy_visitor")
    window.kmklabs ||= {}
    window.kmklabs.gtm ||= {}
    window.kmklabs.gtm.visitor_id ||= visitor_id
    return visitor_id
  }
}
